//@flow
import axios from 'axios';
import { isEmpty } from "lodash";

import { validateEmail, validateRequired, validateMaxLength } from 'h-signup'


const getValidationObjects = () => {
	const required = {
		func: validateRequired,
		error: 'This is required'
	}
	const email = {
		func: validateEmail,
		error: 'Please enter a valid email address'
	}
	const maxLength = {
		func: validateMaxLength(30),
		error: 'Please enter a name of maximum 30 characters'
	}
	const isValueEmpty = (value, errorText = "This is required") => {
		return isEmpty(value) ? errorText : "";
	}
	const smTypeValidations = (value) => {
		const validations = [isValueEmpty(value)].filter(Boolean);
		return validations[0] || "";
	}
	return {
		required, email, maxLength, smTypeValidations
	}
}

const submitNewSMDetails = (data: Object) => new Promise(async (resolve, reject) => {
    try {
        const resp = await axios.post('/gx/api/sm', data);
        resolve(resp.data);
    } catch(e) {
        reject(e);
    }
});

export {
	getValidationObjects,
    submitNewSMDetails
}
